import "./userimg.scss";
import * as React from "react";
import FontAwesomeSolid from "../../Utilities/Platform/FontAwesome/FontAwesomeSolid";

interface Props {
    url?: string;
    loading?: boolean;
    className?: string;
}

interface State {
    loaded: boolean;
}

export default class UserImg extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            loaded: false,
        };
    }

    protected onLoad = (): void => {
        this.setState({
            loaded: true,
        });
    };

    public render(): React.ReactNode {
        return (
            <div className={`user-image ${this.props.className ?? ""}`}>
                {this.props.loading && (
                    <div className="user-loading">
                        <FontAwesomeSolid icon="spinner-third" spin />
                    </div>
                )}
                {!this.state.loaded && (
                    <div className="img-placeholder">
                        <span className="img-placeholder-svg" />
                    </div>
                )}
                {!!this.props.url && (
                    <img
                        src={this.props.url}
                        onLoad={this.onLoad}
                        className={(this.state.loaded ? "" : "hidden")}
                        alt="User Profile Image"
                    />
                )}
            </div>
        );
    }
}
